module.exports = __webpack_public_path__ + "static/fxsinergi-9404c99afe4fa55bf6d06a0a35fab04d.png";